<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <textarea type="text"
           :value="value"
           v-on:input="updateValue($event.target.value)"
           :name="name"
           :required="required"
           :placeholder="placeholder"
           class="form-control"
    ></textarea>
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputTextarea',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputTextarea.vue?0b47f126